import { PreLessonMaterialType } from "./enum";

class FileUtils {
  private static readonly CONTENT_TYPE_MAP: Record<string, PreLessonMaterialType> = {
    "application/pdf": PreLessonMaterialType.PDF,
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": PreLessonMaterialType.DOCX,
    "application/msword": PreLessonMaterialType.DOCX,
  };

  private static readonly FILE_TYPES = [
    PreLessonMaterialType.PDF,
    PreLessonMaterialType.DOCX,
    PreLessonMaterialType.TEXT,
  ];

  public static getTypeFromContentType(contentType: string): PreLessonMaterialType {
    if (this.CONTENT_TYPE_MAP[contentType]) {
      return this.CONTENT_TYPE_MAP[contentType];
    }
    if (contentType.startsWith("text/")) {
      return PreLessonMaterialType.TEXT;
    }
    return PreLessonMaterialType.PDF;
  }

  public static isFileType(type?: PreLessonMaterialType): boolean {
    return type !== undefined && this.FILE_TYPES.includes(type);
  }

  public static isLink(type?: PreLessonMaterialType): boolean {
    return type === PreLessonMaterialType.LINK;
  }
}

export default FileUtils;
